/**
 * reparatii-iphone.js
 * ES module — model picker → price display + CTA label update.
 *
 * Data contract:
 *   <select data-model-picker>
 *     <option data-price="1200">iPhone 13 Pro</option>
 *     <option data-price="range">iPhone 14</option>   ← special case
 *     <option data-price="">— placeholder —</option>   ← hidden state
 *   </select>
 *   <div data-price-display> — text node updated by JS </div>
 *   <a data-cta-label>       — text updated by JS      </a>
 */

const RANGE_LABEL = '100–500 RON';
const CURRENCY    = 'RON';

function formatPrice(raw) {
  if (!raw) return null;
  if (raw === 'range') return RANGE_LABEL;
  const n = parseInt(raw, 10);
  if (Number.isNaN(n)) return null;
  // Format thousands with dot separator (Romanian convention)
  return n.toLocaleString('ro-RO') + ' ' + CURRENCY;
}

function initModelPicker() {
  const picker      = document.querySelector('[data-model-picker]');
  const result      = document.querySelector('.ri-quick-quote__result');
  const priceEl     = document.querySelector('[data-price-display]');
  const ctaEl       = document.querySelector('[data-cta-label]');

  if (!picker || !result || !priceEl) return;

  function update() {
    const opt   = picker.options[picker.selectedIndex];
    const raw   = opt ? opt.dataset.price : '';
    const label = formatPrice(raw);

    if (label) {
      // Show result panel, update price text
      result.removeAttribute('hidden');
      priceEl.textContent = label;

      // Update CTA text to include model name
      if (ctaEl && opt && opt.value) {
        ctaEl.textContent = 'Trimite ' + opt.value + ' în service';
      }
    } else {
      // Hide result panel (placeholder selected)
      result.setAttribute('hidden', '');
      priceEl.textContent = '';
      if (ctaEl) ctaEl.textContent = 'Trimite în service';
    }
  }

  picker.addEventListener('change', update);

  // Run once on load in case browser restores a selection
  if (picker.value) update();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initModelPicker);
} else {
  initModelPicker();
}
